module.exports = __webpack_public_path__ + "img/joinha.b8da5728.png";